// export const MAPBOX_TOKEN="pk.eyJ1Ijoia2V2YWlkIiwiYSI6ImNqazd1ZnpyZjFodGsza21lN2s2NzExdDMifQ.9tdKYtAVbIYop3r4xB2_yg"

// sept 29
export const MAPBOX_TOKEN="pk.eyJ1Ijoia2V2YWlkIiwiYSI6ImNqbW5va3o2ODBjdDgzcHFvOWhlcGgyamQifQ.Mr19KBRaGeZy5BTT6SUPfw"



// WEBPACK FOOTER //
// ./src/config/tokens.js